// removed by extract-text-webpack-plugin
module.exports = {"mouse":"mouse__mouse___BKJG3"};


//////////////////
// WEBPACK FOOTER
// ./src/js/Components/Mouse/mouse.scss
// module id = 128
// module chunks = 0